import { Field, ErrorMessage, Label } from "V2.0/common/fieldset";
import { Input } from "V2.0/common/input";
import { Textarea } from "V2.0/common/textarea";
import { Listbox, ListboxOption, ListboxLabel } from "V2.0/common/listbox";

export default RuleForm;

const ruleOperators = [
  { id: 0, value: "", label: "None Selected" },
  { id: 1, value: "equals", label: "Equals" },
  { id: 2, value: "not_equals", label: "Not Equals" },
  { id: 4, value: "contains", label: "Contains" },
  { id: 5, value: "not_contains", label: "Not Contains" },
  { id: 6, value: "greater_than", label: "Greater Than" },
  { id: 7, value: "less_than", label: "Less Than" },
  { id: 8, value: "exists", label: "exists" },
  { id: 9, value: "not_exists", label: "Not Exists" },
  { id: 10, value: "regex_match", label: "Regex" },
  { id: 11, value: "in", label: "In" },
  { id: 12, value: "not_in", label: "Not In" },
];

function RuleForm(props) {
  const { formState, errors, updateFormState } = props;

  return (
    <div className="flex flex-col gap-y-4">
      <Field>
        <Label>Rule Name *</Label>
        <Input
          type="text"
          value={formState.outputPort}
          onChange={(e) => updateFormState("outputPort", e.target.value)}
          invalid={!!errors.outputPort}
        />
        {errors.outputPort && <ErrorMessage>{errors.outputPort}</ErrorMessage>}
      </Field>

      <Field>
        <Label>Field *</Label>
        <Input
          type="text"
          value={formState.field}
          onChange={(e) => updateFormState("field", e.target.value)}
          invalid={!!errors.field}
        />
        {errors.field && <ErrorMessage>{errors.field}</ErrorMessage>}
      </Field>

      <Field>
        <Label>Operator *</Label>
        <Listbox
          as="div"
          className="my-4"
          value={formState.operator}
          defaultValue={formState.operator}
          onChange={(value) => updateFormState("operator", value)}
        >
          {ruleOperators.map((option) => {
            return (
              <ListboxOption
                key={option.id}
                value={option.value}
              >
                <ListboxLabel>{option.label}</ListboxLabel>
              </ListboxOption>
            );
          })}
        </Listbox>
        {errors.operator && <ErrorMessage>{errors.operator}</ErrorMessage>}
      </Field>

      <Field>
        <Label>Value</Label>
        <Input
          type="text"
          value={formState.value}
          onChange={(e) => updateFormState("value", e.target.value)}
        />
      </Field>
    </div>
  );
}
